const status = {
  development: 'development',
  production: 'production'
}

export default status